import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "./pagination.css"; // Ensure this path is correct
import { Pagination, PaginationItem } from "@mui/material";

const TemplatePagination = ({ currentPage, pageCount, handlePageClick }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <Pagination
            count={pageCount}
            page={currentPage}
            onChange={handlePageClick}
            size={window.innerWidth < 600 ? "small" : "medium"}
            sx={{
                "& .Mui-selected": {
                    backgroundColor: "var(--color-tertiary) !important", // Selected page background
                    color: "white !important", // Selected page text color
                    fontWeight: "bold",
                    borderRadius: "8px",
                },
            }}
        />
    );

    // return (
    //     <ReactPaginate
    //         previousLabel={"Prev"}
    //         nextLabel={"Next"}
    //         breakLabel={"..."}
    //         breakClassName={"break-me"}
    //         pageCount={pageCount}
    //         marginPagesDisplayed={2}
    //         pageRangeDisplayed={5}
    //         onPageChange={handlePageClick}
    //         containerClassName={"pagination"}
    //         subContainerClassName={"pages pagination"}
    //         activeClassName={"active"}
    //         previousClassName={currentPage === 1 ? "disabled" : ""}
    //         nextClassName={currentPage === pageCount ? "disabled" : ""}
    //     />
    // );
};

export default TemplatePagination;
